import { factory } from "../../../utils/apiThunkFactory"

export const addBreakTime = factory.post("coffePause/addBreakTime", "/api/users/add_break_time");